import type { TypeWindowKey } from '@/function/calendar/calendar.window';
import { dropById, upsertById } from '@/store/api/base/api.cache';
import { EVENTS_TAG, externalCalendarApi } from '@/store/api/calendar/calendar.external.api';
import { type TypeAppDispatch, store } from '@/store/store';
import type { TypeExternalCalendar } from '@/types/calendar/types.calendar.external';

const cachedWindows = (): TypeWindowKey[] =>
    externalCalendarApi.util.selectCachedArgsForQuery(store.getState(), 'listExternalWindow') as TypeWindowKey[];

export const writeExternalCalendar = (dispatch: TypeAppDispatch, calendar: TypeExternalCalendar): void => {
    dispatch(externalCalendarApi.util.updateQueryData('listExternalCalendars', undefined, (draft) => upsertById(draft, calendar)));
    dispatch(externalCalendarApi.util.invalidateTags([EVENTS_TAG]));
};

export const dropExternalCalendar = (dispatch: TypeAppDispatch, calendarId: string): void => {
    dispatch(externalCalendarApi.util.updateQueryData('listExternalCalendars', undefined, (draft) => dropById(draft, calendarId)));
    for (const key of cachedWindows()) {
        dispatch(externalCalendarApi.util.updateQueryData('listExternalWindow', key, (draft) => draft.filter((entry) => entry.calendarId !== calendarId)));
    }
};
